import constConf from '../../../constconf'
import axios from 'axios'

export default {
    tagAll: (context, botId) => {
        let url = constConf.shop.url + '/tag/all/' + botId
        context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                if (response.ok === true) {
                    context.commit('tagAll', response.response.data)
                } else {
                    context.commit('tagAll', [])
                }
            })
    },
    tagCreate: (context, data) => {
        let method = 'post'
        let url = constConf.shop.url + '/tag/create'
        if (data.id != null) {
            method = 'put'
            url = constConf.shop.url + '/tag/update'
        }
        let payload = { method: method, url: url, data: data }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                if (response.ok) {
                    let functionName = { put: 'tagUpdate', post: 'tagCreate' }
                    context.commit(functionName[method], response.response.data)
                }
                return response
            })
    },
    tagDelete: (context, tagId) => {
        let payload = { method: 'delete', url: constConf.shop.url + '/tag/delete/' + tagId }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                if (response.ok) {
                    context.commit('cardDelete', response.response.data)
                }
                return response
            })
    },
    cardTagsInCard: (context, { cardId, botId }) => {
        let url = constConf.shop.url + '/card-tag/all-in-card/' + cardId + '?bot_id=' + botId
        context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                if (response.ok === true) {
                    context.commit('cardTagsInCard', response.response.data)
                } else {
                    context.commit('cardTagsInCard', [])
                }
            })
    },
    createForCard: (context, data) => {
        let url = constConf.shop.url + '/card-tag/create-for-card/' + data.card.id
        return context.dispatch('axios/queryWithData', { method: 'post', url: url, data: data }, { root: true })
            .then(response => {
                return response
            })
    },
    importItems: (context, { botId, formData }) => {
        let url = constConf.shop.url + '/catalog/import-items/' + botId
        return axios.post(url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then(response => {
                return response.data
            })
            .catch(error => {
                console.error(error.response)
            })
    },
    getCatalog: (context, botId) => {
        let url = constConf.baseURLApi + '/shop/catalog/get-catalog/' + botId
        return axios.get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                console.error(error.response)
            })
    },
    getLastJob: (context, botId) => {
        let url = constConf.baseURLApi + '/shop/catalog/get-last-job/' + botId
        return axios.get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                console.error(error.response)
            })
    },
    deliverySave: (context, params) => {
        let method = params.id ? 'update' : 'create'
        let url = constConf.shop.url + '/delivery/' + method + '/' + params.bot_id
        return axios.post(url, params)
            .then(response => {
                context.commit(method === 'update' ? 'deliveryUpdate' : 'deliveryCreate', response.data.response.data)
                return response.data
            })
            .catch(error => {
                console.error(error)
            })
    },
    deliveryDelete: (context, deliveryId) => {
        let url = constConf.shop.url + '/delivery/delete/' + deliveryId
        return axios.get(url)
            .then(response => {
                context.commit('deliveryDelete', response.data.response.data)
                return response.data
            })
            .catch(error => {
                console.error(error)
            })
    },
    deliveriesAll: (context, botId) => {
        return axios.post(constConf.baseURLApi + '/shop/delivery/all/' + botId)
            .then(response => {
                context.commit('deliveriesAll', response.data.response.data)
                return response.data
            })
    },
    productCategoriesAll: (context, botId) => {
        return axios.post(constConf.baseURLApi + '/shop/product-category/all/' + botId)
            .then(response => {
                context.commit('productCategoriesAll', response.data.response.data)
                return response.data
            })
    },
    orderAll: (context, params) => {
        return axios.post(constConf.baseURLApi + '/shop/card/order-all/' + params.botId, params)
            .then(response => {
                context.commit('cardAll', response.data.response.data)
                context.commit('clients/loadClients', response.data.response.clients, { root: true })
                context.commit('deliveriesAll', response.data.response.deliveries)
                return response.data
            })
    },
    changeStatus: (context, params) => {
        return axios.get(constConf.baseURLApi + '/shop/card/change-status/' + params.orderId + '?status=' + params.status)
            .then(response => {
                context.commit('cardUpdate', response.data.response.data)
                return response.data
            })
    },
    changePayed: (context, params) => {
        return axios.get(constConf.baseURLApi + '/shop/card/change-payed/' + params.orderId + '?payed=' + params.status)
            .then(response => {
                context.commit('cardUpdate', response.data.response.data)
                return response.data
            })
    },
    getOrder: (context, orderId) => {
        return axios.get(constConf.baseURLApi + '/shop/card/order/' + orderId)
            .then(response => {
                context.commit('cardCreate', response.data.response.data)
                return response.data
            })
    },
    promoAll: (context, params) => {
        return axios.post(constConf.baseURLApi + '/shop/promo/all/' + params.botId, params)
            .then(response => {
                context.commit('promoAll', response.data.response.data)
                return response.data
            })
    },
    promoSave: (context, params) => {
        let method = params.id ? 'update' : 'create'
        let url = constConf.shop.url + '/promo/' + method + '/' + params.bot_id
        return axios.post(url, params)
            .then(response => {
                context.commit(method === 'update' ? 'promoUpdate' : 'promoCreate', response.data.response.data)
                return response.data
            })
            .catch(error => {
                console.error(error)
            })
    },
    promoDelete: (context, deliveryId) => {
        let url = constConf.shop.url + '/promo/delete/' + deliveryId
        return axios.get(url)
            .then(response => {
                context.commit('promoDelete', response.data.response.data)
                return response.data
            })
            .catch(error => {
                console.error(error)
            })
    },
    catalogStockEdit: (context, { id, stockQuantity, botId }) => {
        let payload = { method: 'post', url: constConf.shop.url + '/catalog/catalog-stock-edit/' + botId }
        payload['data'] = { offer_id: id, stock_quantity: stockQuantity }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                // if (response.ok) {
                //     context.commit('catalogStockEdit', response.response.data)
                // }
                return response
            })
    }
}
